module.exports = __webpack_public_path__ + "static/media/appetizer-bg.e76c6459.png";